module.exports = __webpack_public_path__ + "img/视光中心.1a51f900.png";